import { ColdLeadAggregationResult } from 'router/subrouters/DataRoom/models/Dashboard';
import { getUserFullName } from 'utils';

export const getColdLeadUserInfo = (
  lead: Partial<ColdLeadAggregationResult>,
) => {
  const { firstName, lastName, email } = lead;

  const fullName = getUserFullName(firstName, lastName);

  if (!fullName) return email || '';

  if (!email) return fullName;

  return `${fullName} (${email})`;
};
